class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
    this.addEventListener('click', this.handleUpsellClick.bind(this));
  }

  handleUpsellClick(evt) {
    const sizeButton = evt.target.closest('[data-marisola-upsell-size]');
    if (sizeButton) {
      this.handleUpsellSizeClick(sizeButton);
      return;
    }

    const button = evt.target.closest('[data-marisola-upsell-add]');
    if (!button) return;

    const variantId = button.dataset.variantId;
    const fallbackUrl = button.dataset.fallbackUrl;
    if (!variantId) return;

    button.setAttribute('aria-disabled', 'true');
    button.disabled = true;
    const originalText = button.textContent;
    button.textContent = 'Adding...';

    const body = JSON.stringify({
      id: variantId,
      quantity: 1,
      sections: this.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname,
    });

    fetch(`${window.routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          window.location = fallbackUrl;
          return;
        }
        this.renderContents(response);
      })
      .catch(() => {
        window.location = fallbackUrl;
      });
  }

  handleUpsellSizeClick(sizeButton) {
    if (sizeButton.disabled) return;

    const upsell = sizeButton.closest('.marisola-upsell');
    if (!upsell) return;

    upsell.querySelectorAll('[data-marisola-upsell-size]').forEach((btn) => btn.classList.remove('is-selected'));
    sizeButton.classList.add('is-selected');

    const addButton = upsell.querySelector('[data-marisola-upsell-add]');
    if (!addButton) return;

    const variantId = sizeButton.dataset.variantId;
    addButton.dataset.variantId = variantId;

    const fallbackUrl = addButton.dataset.fallbackUrl;
    if (fallbackUrl) {
      const baseUrl = fallbackUrl.split('?')[0];
      addButton.dataset.fallbackUrl = `${baseUrl}?variant=${variantId}`;
    }
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
